/**
 * アコーディオンの開閉を制御するクラス
 */
export default class Accordion {
    /**
     * 指定されたセレクタに一致する全てのアコーディオンを初期化
     * @param {string} headerSelector - アコーディオンヘッダーのセレクタ
     * @param {string} contentClass - アコーディオンコンテンツのクラス名
     */
    static initialize(headerSelector = '.accordion-header', contentClass = 'accordion-content') {
        setTimeout(() => {
            const headers = document.querySelectorAll(headerSelector);
            for (const header of headers) {
                const content = header.nextElementSibling;
                if (content?.classList.contains(contentClass)) {
                    new Accordion(header, content);
                }
            }
        }, 500);
    }

    /**
     * アコーディオンを初期化
     * @param {HTMLElement} header - アコーディオンのヘッダー要素
     * @param {HTMLElement} content - アコーディオンのコンテンツ要素
     */
    constructor(header, content) {
        this.header = header;
        this.content = content;
        // data-accordion-open属性の値を初期状態として使用（デフォルトはfalse）
        this.isOpen = header.getAttribute('data-accordion-open') === 'true';
        this.init();
    }

    /**
     * 初期設定
     */
    init() {
        this.header.addEventListener('click', () => this.toggle());
        this.updateState();
    }

    /**
     * アコーディオンの開閉を切り替え
     */
    toggle() {
        this.isOpen = !this.isOpen;
        this.updateState();
    }

    /**
     * 状態を更新して表示を切り替え
     */
    updateState() {
        this.header.setAttribute('data-accordion-open', this.isOpen);

        if (this.isOpen) {
            this.content.style.maxHeight = `${this.content.scrollHeight}px`;
        } else {
            this.content.style.maxHeight = '0';
        }
    }
}